import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxStorageFirebaseuiModule} from 'ngx-storage-firebaseui';
import {GettingStartedComponent} from './getting-started/getting-started.component';
import {UsageComponent} from './usage/usage.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {MarkdownModule} from 'ngx-markdown';
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonModule} from '@angular/material/button';
import {FlexLayoutModule} from '@angular/flex-layout';
import {GalleryModule} from '@ngx-gallery/core';
import {LightboxModule} from '@ngx-gallery/lightbox';
import {environment} from '../environments/environment';
import {AngularFireModule} from '@angular/fire';
import {AngularFireAnalyticsModule} from '@angular/fire/analytics';


export function firebaseAppNameFactory() {
  return `you_app_name`;
}

@NgModule({
  declarations: [
    AppComponent,
    GettingStartedComponent,
    UsageComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'serverApp'}),
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FlexLayoutModule,
    MarkdownModule.forRoot({loader: HttpClient}),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    NgxStorageFirebaseuiModule.forRoot(environment.firebase),
    GalleryModule,
    LightboxModule,
    MatTabsModule,
    MatButtonModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
